import { render, staticRenderFns } from "./Fortalecimento.vue?vue&type=template&id=264d307c"
import script from "./Fortalecimento.vue?vue&type=script&lang=js"
export * from "./Fortalecimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports